import axios from "axios";
import Vue from "Vue";
import AppBase from "../AppBase";
import { NewsCollection } from "../../models";


export default class NewsApp extends AppBase {
  constructor() {
    super();
  }

  init() {
    super.init();

    this.data = {
      items: []
    };

    this.vm = new Vue({
      el: "#js-newsItems",
      data: this.data,
      methods: {}
    });

    axios.get("/data/news.json")
    .then(
      response => {
        this.news = new NewsCollection().init(response.data.data);
        this.render();
        this.dispatcher.trigger("init");
      },
      error => {
        console.log(error);
      }
    );
  }

  render() {
    Vue.set(this.data, "items", this.news.items.toJS());
  }
}



// WEBPACK FOOTER //
// ./src/js/apps/modules/NewsApp.js